import { TFunction } from 'i18next'
import { filterByObjectValues } from './filterByObjectValues'
import { order } from './order'

const filterByPipelineStatus = (
  assignments: Workflow[],
  pipelineStatus: string | null = null,
  t: TFunction,
) => {
  if (!pipelineStatus) {
    return assignments
  }

  return assignments?.filter(
    item => item.pipelineStatus === t(`table.body.${pipelineStatus}`),
  )
}

const filterBySearch = (
  assignments: Workflow[],
  search: string | null = null,
): Workflow[] => {
  const keys = ['fullName', 'cpf', 'pipelineStatus']

  if (!search) {
    return assignments
  }

  return filterByObjectValues<Workflow>(assignments, keys, search)
}

const getAssignments = ({
  assignments,
  search,
  filter,
  orderBy,
  orientation,
  t,
}: {
  assignments: Workflow[]
  search?: string | null
  filter?: string | null
  orderBy?: string | null
  orientation?: string | null
  t: TFunction
}): Workflow[] => {
  const assignmentsFilteredByPipelineStatus = filterByPipelineStatus(
    assignments,
    filter,
    t,
  )
  const assignmentsFilteredBySearch = filterBySearch(
    assignmentsFilteredByPipelineStatus,
    search,
  )
  const safeOrderBy = orderBy || ''
  const safeOrientation = orientation || ''

  if (!safeOrderBy && !safeOrientation) {
    return assignmentsFilteredBySearch
  }

  return order(assignmentsFilteredBySearch, safeOrderBy, safeOrientation)
}

export { getAssignments, filterByPipelineStatus }
